import Button from '@components/Button/Button';
import type { EmailSignatureV2 } from '@components/EmailSignaturev2/types';
import { useUserDetails } from '@components/WithUser/WithUser';
import { useRouter } from 'next/router';
import { type FC, useCallback } from 'react';

import OnboardingPreviewContainer from '../../OnboardingPreviewContainer';
import styles from './OnboardingPreviewPageForMobile.module.scss';

type OnboardingPreviewPageForMobileProps = {
  emailSignature: EmailSignatureV2;
  emailSignatureHasLoaded: boolean;
};

const OnboardingPreviewPageForMobile: FC<React.PropsWithChildren<OnboardingPreviewPageForMobileProps>> = ({
  emailSignature,
  emailSignatureHasLoaded,
}) => {
  const { user } = useUserDetails();
  const router = useRouter();

  const onClickCreateNewAccount = useCallback(() => {
    if (user?.isAnonymous === false) {
      router.push('/onboarding/email-signature/setup');
    } else {
      router.push('/onboarding/email-signature/signup');
    }
  }, [router, user?.isAnonymous]);

  return (
    <div className={styles['preview-section']}>
      <div className={styles['preview-wrapper']}>
        <div className={styles['preview-container']}>
          <OnboardingPreviewContainer
            isLiteVersion={true}
            emailSignatureHasLoaded={emailSignatureHasLoaded}
            emailSignature={emailSignature}
            isWithoutImage={emailSignature.images.length === 0}
          />
        </div>
      </div>
      <h1 className={styles['introduction-header']}>Your new signature is almost ready!</h1>
      <p className={styles['introduction-subtext']}>
        <b>Create a free account</b> to get your signature & customize it even further by adding pictures and
        changing color.
      </p>

      <div className={styles['get-signature-button-container']}>
        <Button size="large" onClick={onClickCreateNewAccount} loading={false}>
          Get my signature
        </Button>
      </div>
    </div>
  );
};

export default OnboardingPreviewPageForMobile;
